import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class AppLanguageService {
  private language: BehaviorSubject<string>;
  constructor() {
    const oldLanguage = localStorage.getItem("oldLanguage") || "en";
    this.language = new BehaviorSubject(oldLanguage);
  }

  get currentLanguage(): Observable<string> {
    return this.language.asObservable();
  }

  set Language(newLanguage: string) {
    localStorage.setItem("oldLanguage", newLanguage);
    this.language.next(newLanguage);
  }
}
